import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyAn6wO39uXIlb_EZDTMIvCyUh1i-o4HtNE",
    authDomain: "quad-cores.firebaseapp.com",
    projectId: "quad-cores",
    storageBucket: "quad-cores.firebasestorage.app",
    messagingSenderId: "764351776211",
    appId: "1:764351776211:web:56d3475e62b77183001b26",
    measurementId: "G-SHJKNNJY5R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let appCheck;
let messaging = null;

if (typeof window !== 'undefined') {
    if (import.meta.env.DEV) {
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6Le6w2ssAAAAAL_I6u9scKX4IPjnrUHkGZjWUPXw'),
        isTokenAutoRefreshEnabled: true
    });

    try {
        messaging = getMessaging(app);
    } catch (_) {
        // Messaging not supported in this browser (e.g. Safari < 16)
    }
}

// Register FCM token and send to backend. Returns the token or null.
// apiEndpoint: '/push/token' for admin, '/push/portal/token' for portals
export async function registerPushToken(apiInstance, apiEndpoint = '/push/token') {
    if (!messaging) return null;
    if (Notification.permission === 'denied') return null;

    try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return null;

        const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
        const token = await getToken(messaging, vapidKey ? { vapidKey } : undefined);
        if (!token) return null;

        await apiInstance.post(apiEndpoint, { fcm_token: token, platform: 'web' }).catch(() => {});
        sessionStorage.setItem('fcm_token', token);
        return token;
    } catch (err) {
        console.warn('[FCM] Token registration failed:', err.message);
        return null;
    }
}

// Unregister FCM token on logout
export async function unregisterPushToken(apiInstance, apiEndpoint = '/push/token') {
    const token = sessionStorage.getItem('fcm_token');
    if (!token) return;
    sessionStorage.removeItem('fcm_token');
    await apiInstance.delete(apiEndpoint, { data: { fcm_token: token } }).catch(() => {});
}

// Foreground message handler — call once at app root to show in-app toasts
export function onForegroundMessage(callback) {
    if (!messaging) return () => {};
    return onMessage(messaging, callback);
}

export { app, appCheck, messaging };
